import { render } from "./JoinUsView.vue?vue&type=template&id=31cb1c50&scoped=true"
import script from "./JoinUsView.vue?vue&type=script&lang=js"
export * from "./JoinUsView.vue?vue&type=script&lang=js"

import "./JoinUsView.vue?vue&type=style&index=0&id=31cb1c50&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31cb1c50"]])

export default __exports__